// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__ApScI","Logo":"Toolbar_Logo__3Lk47","Clock":"Toolbar_Clock__3cpSj","DesktopOnly":"Toolbar_DesktopOnly__LuPaL"};